export default function SecurityGroupCreateController(
  $scope,
  $location,
  $state,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  $scope.securityGroupName = '';
  $scope.datamodelTags = [];
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.existingNames = {};

  securityGroupsService.getAllSecurityGroups().then(function (response) {
    $scope.existingNames = {};
    response.data.data.forEach((group) => {
      $scope.existingNames[group.name.toLowerCase()] = true;
    });
  });

  $scope.nameExists = function () {
    return $scope.existingNames[($scope.securityGroupName || '').toLowerCase()];
  };

  $scope.submitcreateNewSecurityGroupForm = function () {
    if (
      $scope.securityGroupName &&
      $scope.securityGroupName.length > 0 &&
      !$scope.sending &&
      !$scope.createNewSecurityGroupForm.$error.maxlength
    ) {
      $scope.errorFlag = false;
      $scope.sending = true;
      var data = {
        name: $scope.securityGroupName,
        attrs: {
          description: $scope.description,
        },
        tags: (function () {
          var arr = [];
          for (var i = 0; i < $scope.datamodelTags.length; i++) {
            arr.push($scope.datamodelTags[i].text);
          }
          return arr;
        })(),
      };
      securityGroupsService.postNewGroup(data).then(
        function successCallback() {
          $scope.sending = false;
          $state.go('admin.securitygroups', {
            create: true,
          });
        },
        function errorCallback(error) {
          $scope.sending = false;
          var errorMsg = gettextCatalog.getString('An error occurred while creating the group');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message;
            } else {
              errorMsg += ': ' + error.status.toString();
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
        },
      );
      return true;
    } else {
      return false;
    }
  };

  $scope.nameChanged = function () {
    window.dataLayer.push({
      event: 'securityNameChanged',
    });
  };

  $scope.descriptionChanged = function () {
    window.dataLayer.push({
      event: 'securityDescriptionChanged',
    });
  };

  $scope.tagAdded = function () {
    tagsChanged('securityTagAdded');
  };
  $scope.tagRemoved = function () {
    tagsChanged('securityTagRemoved');
  };

  function tagsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.datamodelTags.length,
      },
    });
  }
}
